(() => {
  if (window.cooldoProductColumns) {
    window.cooldoProductColumns.init(document);
    return;
  }
  const controllers = new WeakMap();
  const selector = '.iurop-product__layout';
  function init(scope) {
    const layouts = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) layouts.unshift(scope);
    layouts.forEach(layout => {
      if (controllers.has(layout)) return;
      const columns = [...layout.children].filter(child => child.matches('.iurop-gallery, .cooldo-broth-gallery, .iurop-product__info'));
      if (columns.length !== 2 || !window.ResizeObserver) return;
      const root = layout.closest('[data-product-root]');
      const header = document.querySelector('[data-cooldo-header]');
      const stickyCart = [...document.querySelectorAll('[data-sticky-atc]')].find(form => form.dataset.productInstance === root?.dataset.productInstance);
      const desktop = matchMedia('(min-width: 990px)');
      let frame = 0;
      let disposed = false;
      function update() {
        frame = 0;
        if (disposed || !layout.isConnected) return;
        let active = -1;
        let top = 0;
        if (desktop.matches) {
          const heights = columns.map(column => column.getBoundingClientRect().height);
          if (heights.every(height => height > 0) && Math.abs(heights[0] - heights[1]) > 2) {
            active = heights[0] < heights[1] ? 0 : 1;
            const headerTop = header ? parseFloat(getComputedStyle(header).top) || 0 : 0;
            const headerSpace = (header?.getBoundingClientRect().height || 0) + headerTop + 16;
            const bottomSpace = stickyCart ? stickyCart.getBoundingClientRect().height + 32 : 24;
            top = Math.round(Math.min(headerSpace, window.innerHeight - bottomSpace - heights[active]));
          }
        }
        columns.forEach((column, index) => column.toggleAttribute('data-sticky-column', index === active));
        layout.dataset.adaptiveSticky = active < 0 ? 'none' : active === 0 ? 'left' : 'right';
        const value = `${top}px`;
        if (layout.style.getPropertyValue('--product-column-top') !== value) layout.style.setProperty('--product-column-top', value);
      }
      function schedule() {
        if (!disposed && !frame) frame = requestAnimationFrame(update);
      }
      const observer = new ResizeObserver(schedule);
      [layout, ...columns, header, stickyCart].filter(Boolean).forEach(element => observer.observe(element));
      desktop.addEventListener('change', schedule);
      window.addEventListener('resize', schedule, { passive: true });
      layout.addEventListener('load', schedule, true);
      layout.addEventListener('toggle', schedule, true);
      document.fonts?.ready.then(schedule);
      controllers.set(layout, () => {
        disposed = true;
        cancelAnimationFrame(frame);
        observer.disconnect();
        desktop.removeEventListener('change', schedule);
        window.removeEventListener('resize', schedule);
        layout.removeEventListener('load', schedule, true);
        layout.removeEventListener('toggle', schedule, true);
        columns.forEach(column => column.removeAttribute('data-sticky-column'));
        delete layout.dataset.adaptiveSticky;
        layout.style.removeProperty('--product-column-top');
        controllers.delete(layout);
      });
      update();
    });
  }
  window.cooldoProductColumns = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(layout => controllers.get(layout)?.());
  });
})();
